const initialState = {
    vehicle_info: JSON.parse(localStorage.getItem('vehicle_info')) || null,
};

const vehicleInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_VEHICLE_INFO':
            return {
                ...state,
                vehicle_info: action.payload,
            };
        default:
            return state;
    }
};

export default vehicleInfoReducer;